<template>
  <b-container>
    <h1 class="text-left mb-4">Forrás kategóriák</h1>

    <h3 class="text-left section-title">Főkategóriák</h3>

    <b-row class="mb-4">
      <b-col v-for="(category, index) in categories" :key="index" md="6">
        <MainCategoryItem
          :category="category"
          @delete-category="openDeleteModal"
          @edit-category="handleEditMainCategory"
        />
      </b-col>
    </b-row>

    <p
      class="d-flex align-items-center add-main-cat-btn flex-row-reverse"
      @click="() => this.$router.push('/fund-categories/add-main-category')"
    >
      Új főkategória létrehozása
      <font-awesome-icon icon="fa-solid fa-plus" class="mr-2" />
    </p>

    <h3 class="text-left section-title">Alkategóriák</h3>

    <b-list-group>
      <b-row>
        <div v-for="subCategory in subCategories" :key="subCategory._id" class="col-12 col-md-6 mb-4">
          <SubCategoryListItem
            :title="subCategory.title"
            :id="subCategory._id"
            @delete-category="openDeleteSubCategoryModal"
            @edit-category="openEditSubCategoryModal"
          />
        </div>
      </b-row>
    </b-list-group>

    <p class="d-flex align-items-center add-main-cat-btn flex-row-reverse" @click="openAddSubCategoryModal">
      Új alkategória felvétele
      <font-awesome-icon icon="fa-solid fa-plus" class="mr-2" />
    </p>

    <DeleteMainCategory
      :title="categoryToDelete.title"
      :_id="categoryToDelete._id"
      @delete-category="deleteMainCategory"
    />
    <DeleteSubCategory
      :title="subCategoryToDelete.title"
      :_id="subCategoryToDelete._id"
      @delete-category="deleteSubCategory"
    />
    <EditSubCategory :category="subCategoryToEdit" @patched-sub-category="handlePatchedSubCategory" />
    <AddSubCategory @added-sub-category="addNewSubCategory" />
  </b-container>
</template>

<script>
import MainCategoryItem from '../../../components/MainCategoryItem.vue'
import SubCategoryListItem from '../../../components/SubCategoryListItem.vue'
import DeleteMainCategory from './modals/DeleteMainCategory.vue'
import DeleteSubCategory from './modals/DeleteSubCategory.vue'
import EditSubCategory from './modals/EditSubCategory.vue'
import AddSubCategory from './modals/AddSubCategory.vue'
import {
  getAllCategories,
  getAllSubCategories,
  deleteMainCategory,
  deleteSubCategory
} from '../../../api/fundMapCategories'
export default {
  data() {
    return {
      categories: [],
      subCategories: [],
      categoryToDelete: { title: '', _id: '' },
      categoryToEdit: { title: '', _id: '', icon: '', subCategories: [] },
      subCategoryToEdit: { title: '', _id: '' },
      subCategoryToDelete: { title: '', _id: '' },
      addMainOpen: false,
      editMainOpen: false,
      addSubOpen: false
    }
  },
  components: {
    MainCategoryItem,
    SubCategoryListItem,
    DeleteMainCategory,
    DeleteSubCategory,
    EditSubCategory,
    AddSubCategory
  },
  async mounted() {
    try {
      const categories = await getAllCategories()
      this.categories = categories
    } catch (e) {
      console.log('Categories fetch error')
      this.categories = []
    }

    try {
      const subCategories = await getAllSubCategories()
      this.subCategories = subCategories
    } catch (e) {
      console.log('Sub categories fetch error')
      this.subCategories = []
    }
  },
  methods: {
    async deleteMainCategory(_id) {
      try {
        await deleteMainCategory(_id)
        this.categories = this.categories.filter(category => category._id !== _id)
      } catch (e) {
        console.log('Delete failed for:', e)
      }
    },
    async deleteSubCategory(_id) {
      try {
        await deleteSubCategory(_id)
        // TODO refresh main category table
        this.subCategories = this.subCategories.filter(category => category._id !== _id)
        this.categories = this.categories.map(category => ({
          ...category,
          subCategories: category.subCategories.filter(subCategory => subCategory._id !== _id)
        }))
      } catch (e) {
        console.log('Delete failed for:', e)
      }
    },

    openAddSubCategoryModal() {
      this.$bvModal.show('add-sub-category')
    },
    openDeleteModal(category) {
      this.categoryToDelete = category
      this.$bvModal.show('delete-main-category')
    },
    async handleEditMainCategory(category) {
      await this.$store.dispatch('setCategoryCacheAction', category)
      this.$router.push('/fund-categories/edit-main-category')
    },
    openEditSubCategoryModal(category) {
      this.subCategoryToEdit = category
      this.$bvModal.show('edit-sub-category')
    },
    openDeleteSubCategoryModal(category) {
      this.subCategoryToDelete = category
      this.$bvModal.show('delete-sub-category')
    },
    addNewCategory(newCategory) {
      this.categories.push(newCategory)
      this.addMainOpen = false
    },
    addNewSubCategory(newSubCategory) {
      this.subCategories.push(newSubCategory)
      this.addSubOpen = false
    },
    handlePatchedCategory(patchedCategory) {
      this.categories = this.categories.map(category => {
        if (category._id === patchedCategory._id) {
          return patchedCategory
        } else {
          return category
        }
      })
    },
    handlePatchedSubCategory(patchedCategory) {
      this.subCategories = this.subCategories.map(category => {
        if (category._id === patchedCategory._id) {
          return patchedCategory
        } else {
          return category
        }
      })

      this.categories = this.categories.map(mainCategory => {
        return {
          ...mainCategory,
          subCategories: mainCategory.subCategories.map(subCategory => {
            if (subCategory._id === patchedCategory._id) {
              return patchedCategory
            } else {
              return subCategory
            }
          })
        }
      })
    },
    toggleSubOpen() {
      this.addSubOpen = !this.addSubOpen
    },
    toggleMainOpen() {
      this.addMainOpen = !this.addMainOpen
    }
  }
}
</script>

<style lang="scss" scoped>
.add-main-cat-btn {
  color: #00903c;
  font-weight: 500;
  font-size: 16px;
  cursor: pointer;
}

.section-title {
  font-weight: 700;
  font-size: 24px;
  margin-bottom: 16px;
}

@media screen and (min-width: 1200px) {
  .section-title {
    font-size: 32px;
  }
}
</style>
